import { computed } from 'vue'

import { usePostHog } from '@/common/composables/usePostHog'

// Feature flag centralization
export function useFeatureFlags() {
  const posthog = usePostHog()

  const isSettingEmailTemplatesEnabled = computed(() =>
    posthog.isFeatureEnabled('setting-email-templates'),
  )

  const isSalesReportsEnabled = computed(() =>
    posthog.isFeatureEnabled('automatic-sales-reporting'),
  )

  const isNewImageCropperApiEnabled = computed(() =>
    posthog.isFeatureEnabled('new_image_cropper_api'),
  )

  const isBetterSettingsEnabled = computed(() => posthog.isFeatureEnabled('better_settings'))

  const isPerformancePromoteDrawerEnabled = computed(() =>
    posthog.isFeatureEnabled('performance-promote-drawer'),
  )

  const isResidencyPromoteDrawerEnabled = computed(() =>
    posthog.isFeatureEnabled('residency-promote-drawer'),
  )

  const isMarketingAnalyticsEnabled = computed(() =>
    posthog.isFeatureEnabled('marketing-analytics'),
  )

  const isGuestThenPayEnabled = computed(
    () => posthog.getInstance()?.getFeatureFlag('guest-then-pay') === 'guest-then-pay',
  )

  const isGuestThenPayCombinedEnabled = computed(
    () => posthog.getInstance()?.getFeatureFlag('guest-then-pay') === 'guest-then-pay-combined',
  )

  const isProgressIndicatorVisible = computed(
    () => posthog.getInstance()?.getFeatureFlag('checkout-progress-indicator') === 'bar-visible',
  )

  return {
    isSettingEmailTemplatesEnabled,
    isSalesReportsEnabled,
    isNewImageCropperApiEnabled,
    isBetterSettingsEnabled,
    isPerformancePromoteDrawerEnabled,
    isResidencyPromoteDrawerEnabled,
    isMarketingAnalyticsEnabled,
    isGuestThenPayEnabled,
    isGuestThenPayCombinedEnabled,
    isProgressIndicatorVisible,
  }
}
